import { motion } from "framer-motion";
import { asset } from "../lib/api";

export default function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative min-h-[380px] md:h-[52vh] flex items-end overflow-hidden bg-[#0B192C]" data-testid="page-hero">
      <img src={asset(image)} alt={title} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C] via-[#0B192C]/60 to-[#0B192C]/40" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 w-full pt-28 pb-14">
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          className="overline text-[#D4AF37] mb-4">{overline}</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-white text-5xl md:text-7xl tracking-tight leading-none">{title}</motion.h1>
        {subtitle && <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.4, duration: 0.8 }}
          className="text-white/80 mt-5 max-w-xl font-light text-base md:text-lg">{subtitle}</motion.p>}
      </div>
    </section>
  );
}
